import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../components/MaterialTypography";
import DynamicTableProps from "./DynamicTableProps";
import { FetchDataGet } from "../../BaseUrl";
import { GETCLIENT } from "../Masters/ClientMaster/Mutation";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { GETACTIVELOGDATA } from "../dashboard/Mutation";
import LoadingSpinner from "../loader/loadercomp";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ActivityLog() {
  const [open, setOpen] = useState(false);
  const [Loader, setLoader] = useState(false);
  const [searchdata, setsearchdata] = useState("");
  const [sortedvalue, setsortedvalue] = useState("");
  const navigate = useNavigate();
  const [differences, setDifferences] = useState([]);
  const [activeLogdData, setActiveLogData] = useState([]);

  // Pagination state
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const columns = [
    { field: "action", label: "Action" },
    { field: "entityType", label: "Module" },
    // { field: "user", label: "User name" },
    { field: "createdDate", label: "Date" },
    { field: "time", label: "Time Stamp" },
  ];

  const validClientData = Array.isArray(activeLogdData) ? activeLogdData : [];

  const filteredData =
    searchdata.length > 2
      ? validClientData.filter((lesson) => {
          const lowerTerm = searchdata.toLowerCase();
          return Object.entries(lesson).some(
            ([key, value]) =>
              typeof value === "string" &&
              value.toLowerCase().includes(lowerTerm)
          );
        })
      : [];

  const sortedData =
    searchdata.length > 2
      ? filteredData
      : [...validClientData].sort((a, b) => {
          const sortOption = sortedvalue?.value || "descending"; // default to descending
          switch (sortOption) {
            case "ascending":
              return new Date(a.createdAt) - new Date(b.createdAt);
            case "descending":
              return new Date(b.createdAt) - new Date(a.createdAt);
            default:
              return validClientData; // default to descending
          }
        });

  useEffect(() => {
    setPage(1);
  }, [searchdata]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getActiveLogData();
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [page, pageSize, searchdata]);

  //   get api integrtaion
  const getActiveLogData = async () => {
    setLoader(true);
    try {
      const response = await FetchDataGet(GETACTIVELOGDATA, { search: searchdata, page, pageSize });
      if (response?.allLogs?.success) {
        const rows = response.allLogs.dataList.map((item) => ({
          action: item.action,
          entityType: item.entityType,
          user: item.user,
          createdDate: moment(item.createdAt).format("YYYY-MM-DD"),
          time: moment(item.createdAt).format("HH:mm:ss"),
          oldValues: item.oldValues,
          newValues: item.newValues,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
        }));
        setActiveLogData(rows);
        setTotalCount(response.allLogs.totalCount || 0);
      } else {
        setActiveLogData([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const compareValues = (oldValues, newValues, parentKey = "") => {
    const changes = [];

    for (const key in oldValues) {
      const oldVal = oldValues[key];
      const newVal = newValues[key];
      const fullKey = parentKey ? `${parentKey}.${key}` : key;

      const bothHaveValue =
        oldVal !== null &&
        newVal !== null &&
        oldVal !== undefined &&
        newVal !== undefined;

      if (
        typeof oldVal === "object" &&
        oldVal !== null &&
        !Array.isArray(oldVal)
      ) {
        changes.push(...compareValues(oldVal, newVal, fullKey));
      } else if (bothHaveValue && oldVal !== newVal) {
        changes.push({
          field: fullKey,
          old: oldVal,
          new: newVal,
        });
      }
    }

    return changes;
  };

  const handleOpen = (data) => {
    if (data.action === "UPDATE") {
      const diffs = compareValues(data.oldValues, data.newValues);
      setDifferences(diffs);
      setOpen(true);
    }
  };

  const handleCloseview = () => {
    setOpen(false);
  };

  const formatValue = (field, value) => {
    if (
      typeof value === "string" &&
      /date|time/i.test(field) &&
      moment(value, moment.ISO_8601, true).isValid()
    ) {
      return moment(value).format("DD-MM-YYYY, HH:mm:ss");
    }
    return value;
  };

  return (
    <DashboardLayout searchdata={searchdata} setsearchdata={setsearchdata}>
      {Loader && <LoadingSpinner />}
      <IconButton sx={{ ml: 2 }} onClick={() => navigate(-1)}>
        <ArrowBackIcon />
      </IconButton>
      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          // onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          sx={{
            "& .MuiDialog-paper": {
              width: "800px", // Set your desired width
              maxWidth: "none", // Prevent it from limiting the width to default sizes
            },
          }}
        >
          <Box p={3}>
            {" "}
            {/* Add padding here for spacing */}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "1%",
                marginBottom: "1%",
              }}
            >
              <CloseIcon onClick={handleCloseview} sx={{ cursor: "pointer" }} />
            </div>
            <DialogTitle
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                fontSize: "16px",
                color: "#000",
                mt: -5,
              }}
            >
              Update Log
            </DialogTitle>
            <MaterialTypography variant="body1" fontWeight="bold">
              Changed Fields
            </MaterialTypography>
            <List dense>
              {differences.length > 0 ? (
                differences.map((change, index) => (
                  <ListItem
                    key={index}
                    alignItems="flex-start"
                    sx={{ alignItems: "flex-start", mb: 1 }} // optional spacing between items
                  >
                    <ListItemText
                      primary={
                        <MaterialTypography fontWeight="600">
                          {change.field}
                        </MaterialTypography>
                      }
                      secondary={
                        <>
                          <MaterialTypography variant="body2">
                            <strong>Old:</strong>{" "}
                            {formatValue(change.field, change.old)}
                          </MaterialTypography>
                          <MaterialTypography variant="body2">
                            <strong>New:</strong>{" "}
                            {formatValue(change.field, change.new)}
                          </MaterialTypography>
                        </>
                      }
                    />
                  </ListItem>
                ))
              ) : (
                <MaterialTypography>No differences found.</MaterialTypography>
              )}
            </List>
          </Box>
        </Dialog>
        <DynamicTableProps
          columns={columns}
          rows={sortedData}
          onView={handleOpen}
          name="Activity Log"
          serverPage={page}
          totalCount={totalCount}
          rowsPerPage={pageSize}
          onPageChange={(event, newPage) => setPage(newPage)}
          ActivityLog={true}
        />
      </div>
    </DashboardLayout>
  );
}

export default ActivityLog;
